import { ForwardedRef, forwardRef, Fragment, useEffect, useRef, useState } from 'react';
import ReportDrawer from '../../../constants/ReportDrawer';
import SidebarOpen from '../../../constants/SidebarOpen';
import { useSidebar } from '../../../helpers/sidebarClose';
import CircleBtn from '../../../constants/CircleBtn';
import ReportHeader from '../../../constants/ReportHeader';
import { useReactToPrint } from "react-to-print";
import VoucherRptFormView from '../../../components/account/reports/voucher_rpt/VoucherRptFormView';
import VoucherRptListView from '../../../components/account/reports/voucher_rpt/VoucherRptListView';
import PrintVoucherRptView from '../../../components/account/reports/voucher_rpt/PrintVoucherRptView';
import { TransactionRpt } from '../../../helpers/models/Models';

const VoucherReportCreateListView = ({ setIconsButton }: { setIconsButton: any }) => {
    const { isOpen, toggleSidebar, closeSidebar } = useSidebar('voucher_rpt');
    const [onVoucherReport, setOnVocuherReport] = useState<TransactionRpt[]>([]);
    const componentListRef = useRef<HTMLDivElement | null>(null);

    const handlePrintCard = useReactToPrint({
        content: () => componentListRef.current!,
    });

    useEffect(() => {
        setIconsButton(<CircleBtn onClick={handlePrintCard} />);
        return () => setIconsButton(null);
    }, []);

    useEffect(() => {
        if (!isOpen) {
            toggleSidebar();
        }
    }, [isOpen, toggleSidebar]); 
    return (
        <>
            <SidebarOpen onClick={toggleSidebar} />
            <ReportDrawer header={<ReportHeader label='Voucher Report' />} open={isOpen} onClose={closeSidebar}>
                <VoucherRptFormView setOnVocuherReport={setOnVocuherReport} />
            </ReportDrawer>
            <VoucherRptListView onVoucherReport={onVoucherReport} />
            <div className='hidden'>
                <div ref={componentListRef}>
                    <PrintVoucherRptView onVoucherReport={onVoucherReport} />
                </div>
            </div>
        </>
    );
}

export default VoucherReportCreateListView